import React, { useEffect, useRef } from "react";
import "./WeAre.css";
import Greenleaf from "../assets/_images/greenleaf10.mov";
import Fruits from "../assets/_images/farmer2.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const WeAre = ({ navG, setNavG }) => {
  useEffect(() => {
    setNavG(true);
  }, []);

  gsap.registerPlugin(ScrollTrigger);

  const refvideo = useRef(null);
  const refwearetagh1 = useRef(null);
  const refwearetagp = useRef(null);
  const refmissionh1 = useRef(null);
  const refmissionp = useRef(null);
  const refpillar1h1 = useRef(null);
  const refpillar2h1 = useRef(null);
  const refpillar3h1 = useRef(null);
  const refpillar4h1 = useRef(null);
  const refpillar1p = useRef(null);
  const refpillar2p = useRef(null);
  const refpillar3p = useRef(null);
  const refpillar4p = useRef(null);
  const refpillarimg = useRef(null);
  const refmap = useRef(null);

  const customtween = (elem, trig, delay, dur = 0.3, strt = "") => {
    gsap.fromTo(
      elem,
      {},
      {
        scrollTrigger: {
          trigger: trig,
          start: strt,
        },
        keyframes: [
          { alpha: 0, y: 300, duration: 0.00001 },
          { delay: delay, alpha: 0.2, y: 150, duration: 0.3 },
          {
            duration: dur,
            y: 0,
            alpha: 1,
          },
        ],
      }
    );
  };

  useEffect(() => {
    const el = refvideo.current;
    gsap.fromTo(
      el,
      { x: 700, alpha: 0 },
      {
        duration: 0.6,
        x: 0,
        alpha: 1,
        scrollTrigger: {
          trigger: el,
          ease: "power4.out",
        },
      }
    );
    const pimg = refpillarimg.current;
    gsap.fromTo(
      pimg,
      { x: -600, alpha: 0 },
      {
        duration: 1,
        alpha: 1,
        x: 0,
        scrollTrigger: {
          trigger: ".wrpillars",
          ease: "power4.out",
        },
      }
    );
    const el1 = refwearetagh1.current;
    customtween(el1, ".weare", 0.2);

    const el2 = refwearetagp.current;
    customtween(el2, ".weare", 0.5);

    const el3 = refmissionh1.current;
    customtween(el3, ".ourmissionwrapper", 0.2, 0.7);

    const el4 = refmissionp.current;
    customtween(el4, ".ourmissionwrapper", 0.5, 0.7);

    const el5 = refpillar1h1.current;
    const el6 = refpillar2h1.current;
    customtween(el5, ".wearepillars", 1.2, 0.7);
    customtween(el6, ".wearepillars", 1.3, 0.7);
    const el7 = refpillar1p.current;
    const el8 = refpillar2p.current;
    customtween(el7, ".wearepillars", 1.5, 0.7);
    customtween(el8, ".wearepillars", 1.6, 0.7);
    const el9 = refpillar3h1.current;
    const el10 = refpillar4h1.current;
    customtween(el9, ".wearepillars", 1.6, 0.7);
    customtween(el10, ".wearepillars", 1.7, 0.7);
    const el11 = refpillar3p.current;
    const el12 = refpillar4p.current;
    customtween(el11, ".wearepillars", 1.9, 0.7);
    customtween(el12, ".wearepillars", 2, 0.7);
    const rmap = refmap.current;
    customtween(rmap, ".wearemap", 1, 1);
  });
  return (
    <div className="wrapper">
      <div className="weare">
        <video
          ref={refvideo}
          className="wearevideo"
          autoPlay
          playsInline
          muted
          loop
          preload
        >
          <source src={Greenleaf} type="video/mp4" />
        </video>
        <div className="weare-wrapper">
          {/* <div className="trail">
            <div className="breadcrumb">
              <p>Home </p> <FontAwesomeIcon icon={faAngleRight} />{" "}
              <p> We are</p>
            </div>
          </div> */}
          <div className="tagweare">
            {/* <h1>
              Grow sustainable. <br /> Grow with us.
            </h1> */}
            <h1 ref={refwearetagh1}>Who we are.</h1>
            <p ref={refwearetagp}>
              We are a leading global provider of specialty agricultural
              nutrition products and a producer of nutrient use efficiency
              solutions.
            </p>
          </div>
        </div>
      </div>
      <div className="ourmission">
        <div className="ourmissionouter">
          <div className="ourmissionwrapper">
            <h1>Our Mission</h1>
            <h2 ref={refmissionh1}>WeCare about sustainability.</h2>
            <p ref={refmissionp}>
              We are commited to engage and make an impact in the global
              agricultural industry providing the most efficient crop
              nutritional products to move us closer towards sustainability.{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="wearepillars">
        <div className="wrpillars-wrapper">
          {/* <img src={Fruits} /> */}
          <div ref={refpillarimg} className="wearepillarimage"></div>
          <div className="wrpillarsright">
            <div className="wrpillarsdiv">
              <h1>Our Values</h1>
              <div className="wrpillars">
                <div className="wrpillar">
                  <h2 ref={refpillar1h1}>Technology Serving the Environment</h2>
                  <p ref={refpillar1p}>
                    We strive to promote and implement the most efficient
                    products and solutions to minimize the over application of
                    nutrients and the resulting waste which is negatively
                    affecting ecosystems globally.
                  </p>
                </div>
                <div className="wrpillar">
                  <h2 ref={refpillar2h1}>Offering Complete Solutions</h2>
                  <p ref={refpillar2p}>
                    More than just a complete product portfolio, we work to
                    provide our customers with holistic solutions that aim to
                    achieve true efficiency in modern sustainable farming
                    systems.
                  </p>
                </div>
                <div className="wrpillar">
                  <h2 ref={refpillar3h1}>Expert Logistics</h2>
                  <p ref={refpillar3p}>
                    We are specialists in logistics with more than 20 years of
                    experience actively seeking custom solutions to ensure the
                    most efficient & competitive delivery. We focus on
                    quality-conscious and effective delivery by working with
                    selected independent inspectors to survey the manufacturing,
                    storing, packaging and container stuffing, certifying that
                    quality & quantities are in order.
                  </p>
                </div>
                <div className="wrpillar">
                  <h2 ref={refpillar4h1}>Quality Assurance</h2>
                  <p ref={refpillar4p}>
                    We do systematic inspections and product validation
                    processes to ensure product quality before we ever put them
                    in the market. Often we test it ourselves first via our own
                    distribution channels and in collaboration with our closest
                    partners. On a regular basis, we visit our suppliers,
                    warehouses and load ports to audit consistent quality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wearemap">
        <div className="wrmap-wrapper">
          <h1>Our Global Reach</h1>
          <h2>
            We are close to you to cover your technical and commercial needs.
          </h2>
          <div ref={refmap} className="wrmap" style={{ marginTop: "8rem" }}>
            {/* <div className="usaofficepin">
              <div className="usaofficepin-line">
                <FontAwesomeIcon
                  style={{ marginRight: "1rem" }}
                  icon={faBuilding}
                />
                <p>USA Offices</p>
              </div>
              <div className="usaofficepin-line">
                <FontAwesomeIcon
                  style={{ marginRight: "1rem" }}
                  icon={faWarehouse}
                />
                <p>USA Distribution</p>
              </div>
            </div>
            <div className="brazilofficepin">
              <p>Brazil Offices</p>
            </div> */}
          </div>
        </div>
      </div>
      {/* <div className="weareteam">
        <div className="weareteam-wrapper">
          <h1>Our Team</h1>
          <h2>Meet our team.</h2>
        </div>
      </div> */}
      <svg height="0" width="0">
        <defs>
          <clipPath id="svgPath" clipPathUnits="objectBoundingBox">
            <path
              fill="#FFFFFF"
              stroke="#000000"
              stroke-width="1.5794"
              stroke-miterlimit="10"
              d="M.9993.378A.5485.5485,0,0,0,.99.2823H.99A.3648.3648,0,0,0,.8531.06.3247.3247,0,0,0,.6514,0C.5558,0,.3264.0686.341.4162L.3417.4306C.343.4545.341.614.4782.6411c.11.0223.16-.0582.1628-.1555C.6417.4625.6417.44.641.417.641.3867.6424.3341.6784.33.7166.3253.7166.3668.7166.4138a.359.359,0,0,1-.0291.14A.1789.1789,0,0,1,.544.673.2073.2073,0,0,1,.5121.6754.2015.2015,0,0,1,.3659.61.3016.3016,0,0,1,.2876.4019C.2827.2536.1878.2273.1428.2273.0589.2273-.0007.3054,0,.4354A.5881.5881,0,0,0,.0353.6267.5144.5144,0,0,0,.553,1,.386.386,0,0,0,.657.984L.6722.9784a.5137.5137,0,0,0,.2911-.34L.9674.6212.9688.6164a.8732.8732,0,0,0,.03-.185L1,.3915V.3859Z"
            />
          </clipPath>
        </defs>
      </svg>
      <svg>
        <defs>
          <clipPath id="svgPath2" clipPathUnits="objectBoundingBox">
            <path
              fill="#FFFFFF"
              stroke="#000000"
              stroke-width="1.5794"
              stroke-miterlimit="10"
              d="M212.0364,56.6853a.0834.0834,0,0,0-.0854.0894.1557.1557,0,0,1-.0267.0851h0a.3.3,0,0,1-.1786.2191l.0492.0007a.3022.3022,0,0,0,.3049-.1912C212.148,56.7659,212.1064,56.6853,212.0364,56.6853Z"
              transform="translate(-211.3293 -56.5681)"
            />
            <path
              class="cls-1"
              d="M212.2451,56.6853a.0834.0834,0,0,0-.0854.0894.1565.1565,0,0,1-.0267.0851h0a.3.3,0,0,1-.1786.2191l.0492.0007a.3023.3023,0,0,0,.3049-.1912C212.3566,56.7659,212.3151,56.6853,212.2451,56.6853Z"
              transform="translate(-211.3293 -56.5681)"
            />
            <path
              class="cls-1"
              d="M211.9181,56.7617a.2392.2392,0,0,0-.0054-.0492h0a.1888.1888,0,0,0-.08-.114.2106.2106,0,0,0-.1188-.03.1838.1838,0,0,0-.1832.213l0,.0073a.1022.1022,0,0,0,.08.1079.0756.0756,0,0,0,.096-.08.3424.3424,0,0,0,0-.0351c0-.0154.0008-.0423.0219-.0445s.0225.0189.0226.043a.1636.1636,0,0,1-.0172.0719.103.103,0,0,1-.0845.061l-.0186.0013a.1266.1266,0,0,1-.0861-.0337.1443.1443,0,0,1-.0462-.1065.0834.0834,0,0,0-.0853-.0894c-.0494,0-.0846.04-.0842.1066a.269.269,0,0,0,.0207.0979.3023.3023,0,0,0,.3049.1911.25.25,0,0,0,.0614-.0083l.0088-.003a.2779.2779,0,0,0,.1717-.1744l.0025-.0088.0007-.0026a.3956.3956,0,0,0,.0175-.0947l.0007-.02v-.003Z"
              transform="translate(-211.3293 -56.5681)"
            />
          </clipPath>
        </defs>
      </svg>
      <svg>
        <defs>
          <clipPath id="mappath" clipPathUnits="objectBoundingBox">
            <path
              fill="#FFFFFF"
              stroke="#000000"
              stroke-width="1.5794"
              stroke-miterlimit="10"
              d="M2119.96,156.1514l.0059-.0008a.1133.1133,0,0,0,.0184-.0007l.0027-.0013.0079.0006.0036-.0006.0054-.0007h.0121l.0068.0007.0049.0008.0016.0018.0016.0009.0135-.0008.004.0008v.0005l-.002.0006a.0371.0371,0,0,0-.0142.0053l-.0041.0016.0035.006-.0032-.0012.0016.0031-.0005.0008-.0009,0-.0067.0051-.0005.0016-.0012.0018-.001,0-.0011,0,.0009,0,.0013.0006-.0019.0047-.006-.0015.0058.0018-.0076.0033-.0033.0013-.0034.0008h-.0007l-.0027.0006a.0181.0181,0,0,0-.0131.0041l-.0122.0039-.0052.003-.0055.0053-.0048.0062c-.0043.0045-.0042.0047-.0092.0008l-.0013,0-.0041-.0014-.0036-.0106-.0007-.0037.0063-.0086.0041-.0041-.0007.0007-.004.0013-.0025-.0012.0014-.0021.0018-.0014.0037,0-.0024,0-.0011-.0048.0011-.0039,0-.0005,0,0-.006-.0048h-.0042l-.008,0-.0071-.0041.0045,0-.0038-.0022.0138-.0024.0034-.0006.0022-.001-.0022,0,.001-.002.0064-.0014.0073-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2120.0228,156.1486l-.0068-.0007h.0068Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-3"
              d="M2120.0039,156.1479l-.0054.0007v-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-1"
              d="M2120.25,156.1723l.0014-.0018.0008-.0016a.05.05,0,0,1,.0182-.003l.0069-.0027.0051-.0014.0033,0,.0034.0013.0022.0011a.0277.0277,0,0,1,.0134.0012l.0027.0038-.0047.0036.0094-.0009.0034.0007h.0067l.0074.0014h.0054l-.0006-.0013.0047,0h.002l.0041.0006.0083.0046.0035.002.0019,0c.0026-.0043.007,0,.01-.002h.0048l0-.0014.0028-.0019h.002l.0034.0006a.0759.0759,0,0,1,.023.0042l.0074,0h.0074l.0084.0031.0065.001.0053,0,.007,0,.0035.001.003.0009.0009,0,0-.0008-.0021-.0017.0035,0,.004.0006a.1064.1064,0,0,1,.0244.0041.0871.0871,0,0,0,.0175.004l.0041.0006.0047.0015c.0016.0007.0055,0,.0033.0039l.0021.0027-.0033,0-.009-.0024-.0065-.0011-.0024.0022.0013.0022.0087.0052-.0063,0-.0061.0057-.0038.0011-.0009,0h-.0041l-.0055.0012-.0012.0023.0047.0051.0055.0045,0,.0006c-.004.0035.0023.0029.0018.0051l-.0008.0042-.0013.0013,0,.0086-.0016.0014,0-.0019-.0012-.0033-.0156-.0145-.0008-.0018-.0007-.0033-.0005-.0013.0027-.0052.0014-.0047-.0015-.0031-.0012-.0008,0,.0016-.0006,0h-.0075c-.0028-.0028-.0073,0-.0073.0042l.0018.0022.0015.0014-.0034.0006-.01-.002-.0021.0014-.0137-.0006-.0026.0021-.0048.012.0009.0007.0041.0013.0061.0008.005.0012.0037.0014.0011.0012,0-.0019-.0012-.0017.0171.0175-.0009.002.0067.0063-.003.0017-.0021-.0018-.0092-.0143-.0043-.0032.0009.0041c.0053.0054.003.0117.0022.0177l-.0014.0052-.0063.0037-.0031,0-.0019.005-.0014.004,0,.0044a.0222.0222,0,0,1,.009.0106l0,.0034-.0027.0014-.0021.0007-.0033-.0021-.0007-.0033-.0023-.0048-.0027-.0013-.0031-.0014-.0006-.004-.0081,0-.0027.0014-.0011-.0036-.0005-.0026-.0029.0012-.0051.0049,0,.0011.0013.0013.0044.0027h.0025l.0038-.0006.0033.0006,0,.0025-.0023.0012c-.0036.0041-.0035.0039.0006.0078l.0076.0085v.004l.0007.0018.002.0069-.0029.0086-.0058.0075-.009.0051-.0086.0034-.0007.0045-.0015.006-.0039,0,0-.0045.0009-.0045-.0055-.0011-.0039.01.001.0016.0058.0064a.0174.0174,0,0,1,.0057.0154l-.0023.0032-.0094.0081-.0017-.0011-.003-.0041-.0033-.0038-.0052-.0044-.0017-.0016-.0023-.0011-.0016.01.0012.0039.001.0012a.0169.0169,0,0,0,.0084.01l.0036.0076c0,.0041.0025.0068.0038.011a.0252.0252,0,0,1-.011-.0081l-.0036-.01-.0043-.0069-.0023-.0056.0006-.0055-.0025-.0106-.0029-.0085-.0028-.0008-.0019.0014-.0041.0008-.0012-.0032v-.0041l-.0014-.0027-.002-.0021-.0009-.0023-.0056-.0076-.0028-.0008-.0065.0021c-.0024,0-.0054-.0005-.0049.0037l-.0013.0022a.04.04,0,0,0-.0116.0122l-.0017.0011c-.0042.0025-.0049.0035-.0036.0082a.0284.0284,0,0,1-.0007.012l-.0058.0084-.0033-.001-.0032-.0077-.007-.0151a.0523.0523,0,0,1-.0053-.0186l-.0009-.0047-.0059.0025-.0053-.0061.003-.001-.0024,0-.0072-.006-.0062-.0028a.0549.0549,0,0,1-.0206-.0006l-.0049-.0038-.0026-.0011-.0084,0a.0191.0191,0,0,1-.01-.0091l-.0043-.0019-.0017.004.0071.0093.0019.0013.0021.0014.0016.0046.0072-.0016.0016-.0021.0037-.0031.0008.0038.0046.0044.0054.0038.0008.0018-.0048.0079-.0007.0041-.0067.0053-.001.0012c-.0072-.0006-.01.0066-.0163.0089a.0581.0581,0,0,0-.0152.0065l-.0026,0-.0027-.003-.0018-.0092,0-.0019c-.0034-.0042-.0045-.01-.0091-.0131l-.0029-.0062-.0038-.0072-.0065-.01-.0049-.0028-.0039-.0049.0035.0053.0057.011c.0021.006.0078.0105.007.0176l.0006.0015.0059.01.0036.0039.0077.0079.0007.0034-.0008.0005.0066.0041.011-.0025.0047-.0016.0028.0018v.0038l-.0007.0033-.0081.0162-.0095.01-.0089.01-.0028.0037a.027.027,0,0,0-.0072.013l0,.0025,0,.0008.0014.0027.0006.0027.001.0074.0017.0027v.0109a.0108.0108,0,0,1-.0077.0116c-.0049.002-.0073.0068-.0113.01l.0006.0033.001.0043,0,.004-.0043.0063-.0042.0052-.0042.01-.0084.01a.0264.0264,0,0,1-.0127.0071l0,0a.0333.0333,0,0,0-.0159.0022l-.0046-.0054.0006-.0026v-.0034l-.0027-.0054-.0027-.0055-.002-.002-.0014-.004-.0014-.0088-.0006-.0061-.0048-.01-.0013-.0027-.0013-.0014-.0007-.0026.0013-.0115.0007-.0027.0027-.0054.0014-.0027,0-.0034-.0024-.0067,0-.0054-.0013-.0027-.0007-.0027-.0007-.0021-.004-.0054-.006-.0088.0013-.0033h0l0-.0037.0006-.003.0013-.0041-.0015-.0027-.0019-.0021-.0054-.0006-.0031,0-.0023-.0017h0l-.0048-.006-.004.0006-.0118.0043-.005,0-.01,0-.0034.0013-.0067-.0014-.0041-.0034h0l-.004-.0034-.0007-.0006-.0027-.0014-.0021-.0067-.0027-.0027-.0006-.0007-.0027-.0034-.0014-.0013-.0027-.0041-.0014-.0066.0008-.0022.0019-.004.0011-.0041,0-.0047-.0006-.0026v-.0028l-.0014-.0013,0-.0027h0l0-.002.0019-.0027.0007-.002.0014-.0027.0034-.0051.0033-.0044.0027-.0041.0034-.0013.0027-.002.004-.0077.002-.0052.0028-.0038.006-.0043.0007-.0026.001-.0012.0025,0a.0117.0117,0,0,0,.0117,0,.0408.0408,0,0,1,.0181-.0046.0427.0427,0,0,0,.0123-.001l.0045.0006.0013.0038-.0008.0064.0006.0015.006.0029.0086.0044.0026.0015.0053.0019.0037-.002a.0062.0062,0,0,1,.01-.0048.0715.0715,0,0,0,.0175.0056l.0013,0a.0134.0134,0,0,1,.0117-.0008l.0033-.0018a.0275.0275,0,0,0,.0028-.0136l-.0029-.0017-.0091,0-.0009,0-.0087.0013-.002,0-.0055-.0074,0-.005-.0013-.0027-.0031.001-.0029.0011.0042.0052-.0007.0027-.0031.0027-.0013.0014-.0047-.003-.0026-.0025-.0006-.0007c0-.004-.0045-.0063-.0036-.0108l-.004-.004-.0082-.0062-.005-.0036-.0012.0006,0,.0013c.003.0027.0039.0073.0082.0089l.0073.0047.0014.003-.0031,0-.0009,0-.0037.0081-.0005,0-.0026.0032-.0056-.0023-.0016-.0025.0028-.0016h.0043l.0014-.0047-.0051-.0039a.0238.0238,0,0,1-.01-.0092l-.0046-.0012-.0032.0018-.006.001-.0048.0031-.0037.0036-.0048.0035-.0011.002c0,.0046-.0028.0067-.0057.0092l-.0047.0016-.0057.0015-.0028,0-.0031-.004-.0054-.0006v-.004l-.0007-.0034a.0141.0141,0,0,0,.0015-.0115l.0012-.0027h0l.0027-.0014.0081.0007h.0041l.0006,0,.0027.0005.0021-.0006.0013-.0034v-.0021l-.002-.0054-.0007-.0013-.0034-.002-.0019-.0008-.0008-.0019.0034-.0014.0022-.0006.0027,0,0-.0011.0015-.0011.0079-.0029.0005-.0022.0036-.0011.004-.0035.002-.0019.0013-.0016.0021,0,.002,0c.0046-.0011.0046-.0013.0032-.0061l0-.005.0056-.0022.001.0061,0,.0009c0,.0043,0,.0043.0047.0031h.0026l.007,0,.0063-.0007.0048-.0041c0-.0046.0024-.0061.0074-.0046l0-.0015c-.0018-.0038-.0013-.0049.0028-.0058l.0093-.0011-.0091.0008-.0049.0006-.0053-.0039.0014-.0088.0055-.0046-.0062.0021-.0037.0037-.004.0025,0,.006,0,.0061-.0024.0053-.0015.0031-.0071.0035-.0044.0019-.0025,0,0-.0017,0-.0022.0015-.0016.0006-.0025,0-.0006c-.0025-.0051-.0025-.0051-.0076-.0038l-.004.0015-.0034-.0015-.0007-.0013-.0006-.0054-.0008-.002,0-.0027.0054-.0036a.03.03,0,0,0,.0149-.0115l.004-.0038,0-.0011,0-.0016.0119-.0039.0111-.0029.004.0006.0086.001.009.0032.0034.0006.0107.0037.0034.0031-.004.0027-.0033,0-.0061-.0008-.0021,0,.0007.0011c.0019.0051.004.0067.0084.0064l-.003-.0029.0044,0,.0023,0,.0014-.0007,0-.0024.0067-.0019.0021-.0006-.0008-.0015-.0015-.0038.0013-.0007.003,0,.0026.0015-.0015.0013,0,.0015.0045-.0005.0118-.0049.0051.001.0041-.0006h.0047l.0013,0,0,0-.0006-.0013-.005-.0029.0224.0044.0015,0,0-.0008-.0023-.0013-.0042-.0047.0038-.0071.0019,0,.0056.0028.0006.0033.0006,0,.003.0029.0024.0036-.001.0079-.0033-.0006.003.0007.0049-.0027.0006-.0049c-.0033.0007-.0072-.0031-.0083-.0083l.0011-.003.0037.003.0005,0,.0009.0005-.0006-.0009,0-.0006.0013-.0014.0021-.0006.0057.0009.0043.0016-.0042-.0016-.0024-.0037h.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-1"
              d="M2119.8668,156.39l0,0c.0014.0046.0072.0049.009.01l.0067.0035a.0183.0183,0,0,1,.0148.0064l.0008.0025.0023.006.0058.0094,0,0,.0008,0c.0041-.0013.0072.001.0105.0028l.0015.0013.0029.0013.0053.0014.0061.0006.0021.0013.002.0015a.013.013,0,0,0,.01.0054l.0008.0026a.0137.0137,0,0,1-.0038.0161l-.0038.0063-.0026.0027v.0114l-.0008.0061-.0012.0027v.0033l-.0029.0071-.0067.005-.0056.0022-.0013.001a.0089.0089,0,0,0-.0075.0118v.0036l-.0058.0112-.0006-.001-.0007.0023-.0033.0029-.0005.0007c-.0005.008-.0031.01-.0106.0064l-.0031,0c.004.0008.0039.0048.0063.0069l-.0036.0071-.01.0017.0011.0059-.0021.0016-.0054-.0007.0045.0038.0013.0008-.0012.0022-.0007.0007-.0006.0007-.0032.008.0023.0043c.0046.0023.0045.0021.0021.0066l-.0023.0065.0038.0056.0007.0013a.0181.0181,0,0,0,.0117.0068l-.0036.002-.0027.0014-.0119-.0039-.008-.0044-.0045-.0045-.0006-.0007-.0014-.0027-.0013-.0006-.0039-.0072.0006-.0025.0007-.0027-.002,0-.0021-.0012.0012-.0029.0015-.0046-.0008-.0068-.0011-.0017,0,.0024-.0013.0025-.0014-.0023,0-.0016-.0006-.0033-.0024-.01-.0009-.0076.0006-.0034a.0381.0381,0,0,0-.0017-.0149l-.001-.01.0006-.006a.077.077,0,0,1-.0012-.0135V156.5l-.0017-.0088-.0054-.0051-.01-.0059-.0053-.0072a.2149.2149,0,0,0-.0134-.0239l-.003-.0041.0017-.0078-.0016-.0046v-.0035l.0027-.0064.0051-.0065.0034-.0067a.0294.0294,0,0,0-.003-.0144l-.0023-.0015-.0028.0033-.0032.0015-.0057-.0026-.0018-.0018-.0017-.0019-.0052-.0061-.0076-.0078a.0185.0185,0,0,1-.0125-.0068l-.0088-.0023-.0048,0a.0861.0861,0,0,1-.02-.0111l-.0019-.0073-.0006-.006-.0077-.01-.0007-.001c.0013-.0048-.0032-.0069-.005-.01l-.0009-.0026,0-.005-.0029-.0026-.0016.0021v.0033a.0541.0541,0,0,1,.0056.0161l.0021.005,0,.0035-.0022-.0016-.0022-.0026-.0016-.0043-.0025-.0042-.0034-.0034.0014-.0014.0008-.0032-.0022-.0029-.0006-.0047,0-.0027v-.0033l-.0052-.0055-.0022-.0028-.0015-.013.0024-.0083,0,0c.0024-.008.01-.0129.0129-.02l.0022-.0054.002,0,.0029-.0008-.0007-.0028,0-.0015,0,.0047-.0042-.0007-.0033-.0075.0028,0,0-.0027,0-.0028.002-.008-.002-.0007-.0026.0006v-.0022c-.0028-.0039.0027-.0092-.0022-.0126l-.0026-.0013-.01-.0028h0l-.0038.0012-.0016.0009h-.002l-.0114.0027.0007-.0026-.0062.0026,0,.0012-.0089.0029h-.0013l-.0008.0013-.0184.0066-.0092.0015-.0006-.0006c.0043-.003.01-.0025.0142-.0047l.0114-.0056-.0008-.0006-.0065,0-.0006-.0017.0025-.0015-.0021-.0007-.0014-.0034a.02.02,0,0,1,.015-.0077l.01-.0037h-.0085l-.0021-.0018.0016-.003.01-.002.002.0007.0029,0,.0008-.0026c-.001-.0057-.001-.0057.0051-.0059l.0036-.0007.0166-.0047.0048-.0006.008.0005a.05.05,0,0,0,.0122.0015l.0034.0006a.03.03,0,0,1,.0139.003l.0026,0a.0714.0714,0,0,1,.021-.0033l.0024-.001h.0018l.0041.0012.0086.0013.0084.0018.0028.0007-.0013.0027a.0381.0381,0,0,1,.0125-.0007.02.02,0,0,1-.014-.0041l.0014-.002.0109-.001-.01,0,.0013-.0027-.0013-.0014-.005.0019-.0078-.0021c.0092-.0057.0187-.0108.03-.0038l.0034.0013.0026,0,.0034,0,.0013.0013.0109-.0029-.0062.0058.0009.0026.0021.0017-.0023.0009-.0017.0006-.0063.0021-.0085,0,.0064.0017a.0141.0141,0,0,0,.0125,0l.003-.0038.0038-.0008.0043-.0018.0028-.0026.0061-.004.0068-.0041h.0047l.0023.0007-.0018.0015-.0066.002-.004.0045v.0042l.0013.0015.003.0008-.0015.0023-.0006.0016.0014,0,0,0,.0061-.0036.0014-.004-.004-.0007.0015-.0054a.0183.0183,0,0,1,.0159-.0042h.0083l.006,0,.0023.0016.0051.0041.0069.0035.0006.003-.0021.0013.0006.0021.0072.0037,0,.0023-.0064.0038-.0038-.0015-.0022-.0022-.0016.0015.001.0029-.0013.0075-.0033-.0012-.0008,0-.0012-.0007.0008.001,0,.0008.0006.0019-.0014.0011-.0012,0-.008-.0023-.0021-.0026-.0048-.0032-.0027.0006h-.0007l-.004-.0012.0044-.0027.002,0,.0063-.0024.0051-.0029.0011-.003-.0035-.0007-.003-.0042-.0054.0012-.0042.002-.0011.0007-.0015,0-.0008.0007-.0055.0048c-.0038.0033-.0038.0033-.0082.001l-.0026.0021-.0088.0049-.0054.0013-.0047.0027-.0013,0-.0041.002-.0014.0006-.0074.0048-.0013.0014,0,.0033.0008.0017.003.0037.0047.0028.0041.0027.002.0007.0038,0,.0017.0018-.0007.0014.0006.0041h0l0,.0021-.001.0019.0025.0007.0037-.0041.0007-.002.0007-.004.0033-.0007.0014-.0007c.0028-.0016.0066-.002.0077-.0059l-.0008-.0043,0-.0026.0047-.0041v-.002l.0026-.004.0028-.0014.0027.0006.0041,0h.0026l.0068.0053-.0021.0034-.0005.0007.0026.0034.0027-.0013.0027-.0013.0044-.0034.0018.0013.0006.0027.0014.0068c-.0008.0043.0031.0052.0053.0073l.0013.0008.0014.0027v.0053l-.0007.0027-.0025.0022.0019.0045.0027,0,.0005.0006c.0017.0046.0012.0071-.0021.0092l-.0025-.0018-.0045.0006,0,0,0,0-.0013-.0013-.0034,0-.0041-.0007.0033-.0043.0069-.007-.0014-.0008-.0058.0026-.0091.0011-.01,0-.0025.0021-.0054.0028.0068-.0021h.003l.0022.0015-.0012.0018h0l-.0018.0034.0007.0027.0006.0006.002.0013.0015,0,.0036-.0018.0025-.0013.001.002-.0016.0021-.01.0042-.0045.0022-.0036.0006.0022-.0039,0-.0008-.0018,0-.0117.0046-.0029.0072-.0062.0011-.0028.002c-.0042,0-.0051.0044-.0081.0061l-.0013.002-.0034.0034,0-.0018-.0011.0031c.0007.0047-.0019.0071-.0057.0091l-.0141.01-.0022.01a.0186.0186,0,0,1-.0007.0127l-.0019.0016-.0019-.0015a.0148.0148,0,0,1-.002-.0105l-.0047-.0046-.0016,0-.0086-.0018-.0037.0028-.0014.0013-.0091-.0018-.0042,0c-.0041.0027-.01.0027-.0118.0088l-.0006.0047a.0193.0193,0,0,0-.0021.02l.0033.0052a.0108.0108,0,0,0,.0147-.0042l.001-.0025.0012-.0019.0081-.0015.0019.0039-.0071.0149.0032.0011h.0082l.004.0067-.0022.01.0047.0077.0052,0,.0082.0013.0035,0,.0033-.005.005-.0034.0058-.003.0032-.0006-.0009.0024,0,.0019.0037-.0015.0025-.0006c.0031.0013.0052.0048.01.004l.0067,0,.0034-.0007h.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-1"
              d="M2120.5057,156.4754l.004.0033,0,.0012c-.0009.0039.0014.0074.0009.0113l.0024.0021.005.0072.0006.0027.0028.0034.0039.0064.0006.0026-.0013.0077,0,.001a.0439.0439,0,0,1-.01.0157l-.0141.0155-.0065.0037-.0073.0032-.0023,0-.0052-.0006a.0077.0077,0,0,1-.01-.0061l-.0015-.0047.0007-.0019-.004.0006.0035-.0052,0,0,0,0-.0053.0036-.0019-.0017-.0044-.0078-.0065-.0019-.0034.0006c-.0066.0024-.0143.0017-.02.0076l-.0046,0a.0235.0235,0,0,0-.0129.0041l-.0033,0-.0021-.0006-.0021-.0021,0-.0031.0039-.009V156.53a.0385.0385,0,0,0-.002-.0122l.002-.002,0,0,0,0,0-.0015c-.0029-.0044.0012-.008.0015-.012l.0006-.0008h.002l.0127-.0059.006-.0017.0069-.0071.0043-.0037.0034-.0031.0054-.0059.0067.0005.0049-.0006.0058-.007.0041,0,0,0-.0012-.0025.0034.0011.0089.0022.0023,0-.0009.0027-.0015.0026,0,0,0,0-.0006.0058.0089.0067.0039-.0011a.0232.0232,0,0,0,.0039-.0122l.0032-.0094.0012-.0009.0009.001.0016.0075Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.499,156.4573l-.001,0-.0067-.0025-.0027,0,.0012-.0025-.0014-.0083a.0321.0321,0,0,0-.0132-.0043l-.0013-.0013-.0022-.0027.002-.0014-.0065-.0059.0012,0,0,0,.0085-.0005.0019.0034,0,.0026c.0023.0041.0023.0041.0054,0a.0068.0068,0,0,1,.0092-.0019l.0124.0049c.0036.0017.0077.0025.0092.0071l.0032.0021.0008.0035-.0006.0016c.0026.0027.0039.0067.0079.0079l.0021.0027-.0015.0012a.0122.0122,0,0,1-.0114-.0065l-.0056-.0035-.0034.0029-.0038.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-1"
              d="M2120.4233,156.4342v.0013l-.0007.0035-.0007,0c-.0044.0012-.0078-.0033-.0123-.0022l-.0054-.0013-.0009-.0009-.0041-.012.0048-.0042.0023-.0014.0027-.0027.0029-.0014c.0027-.0047.0085-.0065.0106-.0117l.0008-.0007.002,0,.0047.0049,0,.0024a.0078.0078,0,0,0,0,.0122l-.0008.0027-.0016.002-.0007.0041-.0026.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2119.96,156.1514l-.0041.0006-.0074.0009-.0059.0013-.0029,0-.0081.0021-.0034,0-.0039.0008-.0125.0045-.0025.0023-.0075.0009-.006,0h-.004l-.0007,0-.005,0-.0017-.0009.0007-.0007h.0039l.0041-.0021.0023,0-.0023-.0005h-.0057l-.0042-.0035,0-.0016,0,0a.0276.0276,0,0,1,.0112-.0028l.0023.0013.0042,0,.0015.0009-.001-.0006-.0027-.0014v-.0014l.0054-.0007.0041-.0006h.0074a.1036.1036,0,0,1,.0222-.002l.0088.0006A.0376.0376,0,0,1,2119.96,156.1514Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.1923,156.5071l.001-.0077.0017-.01,0-.0033.0056-.0059.0066-.0064.0025-.0027.0008-.0009.0016-.0027.0018.0032.0008.0025.0007.0034-.0022.0063-.0089.0278-.0068.0043-.0044-.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.3882,156.4451c-.0053.0012-.0069-.0036-.01-.0062l-.0055-.0087a.0618.0618,0,0,0-.0139-.02l-.0012-.0012-.0017-.0039.0034,0c.006-.0009.007.0051.0106.0076l.0106.0075.0023.0052,0,.0017.0033.0039.0013-.0007.0031.0011,0,.0038-.0012.0065Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1937,156.3823a.021.021,0,0,0-.0085-.01l-.0051-.0063-.0042-.007-.0024-.0081-.0036-.0065-.0014-.0015c-.0005-.0059-.0053-.01-.0066-.0157l.0007-.0007.0053.0018.0053.0092.0018.002.0038.0067.0045.0076.0018.0023.0043.0072.0021.0068.0035.01Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.4652,156.2776a.0116.0116,0,0,1,.0071.0115l.0017.0066-.003.0058-.0071.0037-.0028-.0006-.0014-.0023.0007.0023-.0044.0036-.0017-.0009,0-.0033-.001.0025,0,.0028-.001.005-.0036-.0035-.0022-.0026,0-.0026.005-.0058.0062-.0015.0035-.0044,0-.0018.0013.001.0031-.0013,0-.0085-.0015-.003Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.06,156.2229l0,.0006-.0007.0021v.0027c.003.0036.0043.0086.0089.0108l0,.0013h0l-.0013.0014,0,.0018-.0016.0016h0l-.0034.0006-.0082.0007-.0006.0007h-.0027l-.0027-.0007.0035-.0029-.0022-.0025.0027-.0014-.0007-.0019.0035-.0021-.0044-.0037-.0031-.0031.0006-.0054.0023-.003.0025-.0017h.0027l.0017,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-6"
              d="M2120.4355,156.44l0,.0048-.002.0007-.0013-.0034v-.004l-.0018-.0035.0033-.01.0059-.0035.01-.0015.0014,0,0,0,0,.0014-.0026.003h-.0034l-.007,0-.0023.0014.0009.0034.0027,0,.007,0-.0022.0013,0,0-.002.0053.0027.0083-.0021.0013-.002-.0021-.0027-.0059-.0008-.0011-.0005.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.5617,156.5713l-.01.0081,0,0c-.0066,0-.01.0062-.0153.0091l-.0085,0,0-.0025.0089-.0053a.0555.0555,0,0,0,.0189-.0111l.0062.0009,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-6"
              d="M2120.2128,156.1649l-.0088.0025a.0193.0193,0,0,0-.0131.0079l0,.0023.0055.004a.0245.0245,0,0,1-.011-.0011c-.0045-.0021-.0046-.002-.0022-.0058a.0171.0171,0,0,1,.0166-.0092l.0068-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.0343,156.1979l-.0054.0034-.0028.0012a.0216.0216,0,0,1-.0142,0l.0007-.0024-.0033-.0007.0036-.0019-.002,0-.0013-.0008.0007-.001.0043-.0011.0069.0008.0037,0h.007l.0014.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.0937,156.16l-.0006-.0034.0033-.0007a.0227.0227,0,0,0,.0121-.001l.0082,0,.0047.0006.0025.0009-.0085.0018-.0047,0,0,0,.0022.0008.0071.003-.0074-.0007-.0032,0-.0017.0016c-.0038.0036-.0068.0032-.01-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2119.835,156.1648l.0031.002.0033,0,.0056-.0006.0029,0-.0014.002-.0208.0027.0009-.0017-.0043,0h-.0014l-.002-.0013-.0057-.0011,0-.0008.0132-.003.0047-.0006h.002l0,.0015,0,.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-6"
              d="M2120.5617,156.5713l0-.0007.0037-.0027,0-.0014.0013-.0045.004-.0055v-.01l.0031.0064.0009.0018h.0007l0,.0014,0,.0027.003,0,.0024,0-.001.0019-.0156.0115Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.4038,156.4485l.0046,0,.0041.0006.0022,0-.0027.0021.0061.0018.0013.0011-.0014.0014-.0009,0a.0574.0574,0,0,1-.0149-.0025l-.0073-.0008-.0062-.003.0008-.0035h.002l.0081.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.4334,156.3756l-.0026-.0042c-.0023-.0039.0008-.0078,0-.0118l.0015-.0009.0042.002-.0006.008.0024.0054.0043.0007.0014.0023.0007.0031,0,.0027-.0028-.0013-.0026-.004-.0013,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2119.8215,156.3545l-.0015,0c0-.0041-.0032-.005-.0062-.0064l-.0066-.0032-.0021,0-.006.0026a.01.01,0,0,1,.0126-.0048l.01.0048.0083.0053-.0022.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2119.8844,156.1642l.0067.0012-.0072.0009.0068.0011.008,0,.0035.001-.003.0024-.0115.0006-.0092,0-.0034-.0014.0018-.0025-.0033-.0006-.0008.0006-.0005-.0006.0011-.0028.0055.0007.0048,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.0363,156.2357l.0027-.0027.0021-.002.0046-.0013.0042.0024,0,.0009-.0022.0046-.0038.0035-.0041.002h-.0013l-.0032-.0011.0012-.0029Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.4516,156.391l.0026.0068,0,.0022-.0026.004-.004-.0008-.0014-.0028-.0007-.0023-.0043.0017-.0011,0,0,0c0-.0041.0021-.0059.0059-.0052l.0042-.0049Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.4625,156.2776l-.0021-.0026,0-.0019,0,0-.0009-.0082,0-.0011c.0046.0016.0081.0069.0139.0039l.0013.0006-.0006.0015-.0017.0032,0,0c-.0018.0042-.0049.0015-.0075.0013l-.0007.0013.0007.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.4814,156.57l.0034-.0008h.0026a.0131.0131,0,0,1-.012.01l-.0009-.0027.0015-.0054.0014-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2119.8425,156.36l-.0036.0013-.0026-.0007h-.0047l-.0023-.0011.0023-.0009.0028-.002-.0018-.002a.0143.0143,0,0,1,.0142.0028l-.0009.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-8"
              d="M2120.2694,156.1591a.0435.0435,0,0,1-.0146-.0013l-.0039-.0006-.0017-.0018.0016-.002.01.0015.0027.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-8"
              d="M2119.8627,156.1965l.0021-.0026.0059.0054.0021.0033-.0046.0011-.0048,0h-.0074l0-.0014,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-8"
              d="M2119.856,156.1716h.003l.0014,0-.001.0015-.0008.002h0l-.0048.0034-.0078-.0023-.0006-.0014.0012-.0009.0047-.0018.0012,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.3145,156.3991l-.0039.0045-.0025-.0028,0-.01.0015-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2119.8723,156.1662l.0005.0006-.0013.0034h-.0034l-.004-.0014-.0061-.0012-.0026,0-.0018-.0021.0013-.0011,0,0,.01-.0007.0041.0007,0,.002.0034,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-7"
              d="M2120.3652,156.17l-.0078-.0016-.0014-.0021.0021-.001,0,0a.0734.0734,0,0,0,.0124.0012l.0036.0015-.0057.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0923,156.229l-.0011-.0012,0-.0024c0-.0049-.0023-.0023-.0041-.0017l-.0019.0006.0013-.0042.0024-.0017.004.0014.0018.0035-.002.005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.879,156.1891l.0006-.0007.0014-.0006.0021-.0039.0051.0008.0032-.0017h.0009l.0007.0014h0l.0033.0032.0022.0015-.0007.0014-.0027-.0007h-.0006l-.0027-.0014-.0059-.0018-.0018.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2335,156.1939l0-.0073-.0022-.004-.0021-.0029.0013-.0014.0043.0063.0061.0013-.0016.0039-.0033.0046-.0027,0,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-10"
              d="M2120.5361,156.4416l-.0032.0034c-.004.0033-.0079.0019-.0122,0l.0069-.0017.005-.0033.0035,0v.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8033,156.185c.0049.0014.01.0045.0148.0021l-.0013.0046-.0068-.0019-.0068,0,.0025-.002-.0024-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-11"
              d="M2120.4449,156.39l-.0026.0029-.0017-.004-.0017-.0009,0-.0047.0035.0019.0033,0,.0005.0008-.0005.0038Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-8"
              d="M2120.4308,156.3431l-.0011.004-.0027-.0085.0029-.0034.0015.0038Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-12"
              d="M2120.1849,156.156l-.0085-.0021.006-.0025.0009.001.0032.0016.0046,0-.0028.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-11"
              d="M2120.4435,156.4613a.01.01,0,0,1,.01-.0068l.0027.0007-.0108.0061Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2119.8614,156.16l.01-.0009,0,.0015-.0024.0014-.0023-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-14"
              d="M2120.4327,156.4545l.0008,0a.0564.0564,0,0,0,.0142-.0007l.0008.0009c-.0054,0-.01.0038-.0158.0017Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2120.46,156.4187l.0015.0032-.0017.0055-.0016,0-.0012-.0017.0006-.0061.0011-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.06,156.2229l-.0028-.0008-.0008-.002-.0012-.0013,0-.0031.0029.0007v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2120.2814,156.16l-.0093.0018-.0014-.0017.002-.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8533,156.2377l-.0051.0055-.0026-.0036.0019-.001.001-.0015.0021.0032Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0181,156.1824l.0013-.0041.0007-.0013.0013-.0014a.0073.0073,0,0,1-.0073.0105l-.0035,0,.0074-.0032Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-15"
              d="M2120.4226,156.4566l-.0023-.0013.0025-.0011.0059,0,.0021.0014,0,0,0,0-.0047.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2119.839,156.1609c.0047.002.0085-.0036.0132-.0013A.01.01,0,0,1,2119.839,156.1609Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9147,156.2594l.001-.0073.0009-.0015c.0028.0013.003.0045.0009.0088l-.0041.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8323,156.2235h-.0044l-.0013-.0059.0017-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8634,156.2033l.0047-.0005.0047,0c0,.0043-.004.0023-.0061.0034l-.004-.0007.0021-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-17"
              d="M2119.6777,156.22c-.0018.0043-.0062.0044-.01.0058l-.0009-.0006.0012-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-18"
              d="M2119.9023,156.6086l-.0027,0,.002-.0021.003,0,.0029.0012-.0032.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-19"
              d="M2119.882,156.1618l-.0057.0008-.002-.0022.0019-.0017,0,0,.0037.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8707,156.1993l-.0059-.0054h.0007l.0039.0022.0041-.0022Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2120.4456,156.3848v-.0012l0-.0011,0-.0023.0036.0015-.0005.0044,0,.0009,0,.002h-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-15"
              d="M2120.4651,156.4348l.0022.0008,0,.0021-.0018,0-.0048,0h-.0023l.0011-.0024Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2120.5707,156.5035c-.0041-.0005-.0057-.0035-.0071-.0069Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.041,156.3012l-.0041.004-.0047.0041.0013-.0041Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.4624,156.5483l.0054-.004.0007,0,0,0-.0041.0054,0,.0015-.0017.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3125,156.1722l0,0a.0172.0172,0,0,0-.0115.0019l.0071-.0047Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.4814,156.57c-.002,0-.0044-.0027-.0054.0012l-.0007-.0022.0013-.0018.0014-.0021h.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0984,156.4505l.0012.0081.0015.004-.0034-.0035Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2120.4245,156.3947l.0058-.01.0006.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0073,156.3255l-.0019.0026-.0026-.0019.0015-.0022.0036,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-21"
              d="M2120.3766,156.168l.01.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.912,156.2316l-.0062-.0039.0009-.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2119.7114,156.2364l.0052-.0025-.0052.0058Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9871,156.3688l.0018.002-.0021.0007-.0035,0-.0019,0,.0015-.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2119.8918,156.1884l.0027.0014-.0033.002-.0026-.0008.0016-.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.4679,156.5511l.0013.0047-.0039-.0016-.0015-.0011.002-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8627,156.1965l-.0067.0068-.0021-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-22"
              d="M2119.72,156.2526l.0038,0-.0007-.0031.0007-.0024.0009.0024.0012.0034-.0039.0011h0l-.0018-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-23"
              d="M2120.4736,156.18l-.0062.001-.0018-.0011.0017-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-24"
              d="M2120.16,156.1547h.01l-.0021.0006-.0053.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.25,156.599l-.0011-.0015.0073,0-.0009.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0538,156.2465l.0082-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.1134,156.5429l.0046.0054-.0045-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.02,156.3255l-.0027.0041-.0013-.0041.002-.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.83,156.2134l.0074-.0048C2119.8364,156.2118,2119.8341,156.2133,2119.83,156.2134Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2120.3713,156.1723l.0085.0019h-.0069l-.0016-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0606,156.2141l-.001-.0018.004-.0006.0009.0025-.0025.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0491,156.2411l.0029.0025-.0042.0029Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2120.43,156.4582l.0047,0,.0008.0019-.0017.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-10"
              d="M2119.8215,156.3593l.0015.0016-.0019.0009-.0036-.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-25"
              d="M2120.453,156.3093l-.0031-.0047.0063-.0016-.0019.0043Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0322,156.1946l-.0067,0-.0007-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-26"
              d="M2120.5423,156.4429l.0033.0044,0,.0017-.0017,0,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2120.4368,156.3809l-.0041-.004.0041.0013v.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2120.25,156.599h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-17"
              d="M2120.6107,156.4879l-.0029.0017-.0013-.0014.0025-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-27"
              d="M2119.6379,156.23l.0006.0006-.0084.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.6777,156.22l-.01.0033v-.0012l.0088-.0041Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-21"
              d="M2120.5286,156.2051l-.0075-.0016.0078.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.88,156.2066l-.0027-.0006v-.0027l.0024-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-28"
              d="M2119.8939,156.2506l-.0062-.0017Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9641,156.6159l-.0011-.0019.0043-.0006.0015.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-29"
              d="M2119.6161,156.2365l.0085-.0023A.0073.0073,0,0,1,2119.6161,156.2365Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-30"
              d="M2119.8282,156.1885l-.0077-.0015.01,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-11"
              d="M2120.4779,156.4494l0-.0007.0014-.0046h.0009l0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-31"
              d="M2119.8547,156.5822l-.0015.0046v-.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2457,156.177l-.0061-.0013.0007-.0014h.0013l.0014-.0014.0027.0034,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2120.4665,156.4673l-.0027-.0014.0033-.0012,0,.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-21"
              d="M2119.9641,156.6159h.0047l.0009.0016-.0018,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-15"
              d="M2119.8877,156.262l-.0014.0007-.0026-.002h0v-.002l.0058.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0559,156.2593l.002.0054Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.881,156.2506l-.0082.0031.0068-.0038Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8438,156.2059l.0047-.0027-.0033.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-23"
              d="M2119.856,156.3593l-.0029.002-.0018-.0011.0009-.0015,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.05,156.233l0-.0006.0006-.0007.0024.0007.0018.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8715,156.2134l-.0047.0041C2119.866,156.2134,2119.87,156.2145,2119.8715,156.2134Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-17"
              d="M2120.6161,156.4845h-.0018l-.0028-.0006.0026-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-8"
              d="M2120.1818,156.1859l-.0023.0017-.0018-.0008,0-.0005.0015-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-28"
              d="M2119.8627,156.2053l.004.0007-.0034.0012-.0023,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.03,156.1682l-.0032-.0031.0053.001v.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.4874,156.5693h-.0026l.0017-.0039.0016.0006-.0006.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.04,156.2431l.0041-.002-.0022.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-16"
              d="M2120.4531,156.4367l.0017-.0011.002.0013-.0019.0014-.0018-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8053,156.1817h.0107l-.0113.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8668,156.39l-.0028-.0034h.0028v.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0592,156.2283l-.0024-.0011.0031-.0037Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0059,156.38l.0027.0041-.0038-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-32"
              d="M2119.8567,156.2284l.0033-.0028.0013.0013-.002.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8539,156.179l.0048-.0034h.002l-.0061.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-28"
              d="M2119.7735,156.4282l-.0023-.003.0024,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0782,156.2134l.0006.0054Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2119.8218,156.3408l-.0016-.0044.0011,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9451,156.2107l.0041.0014-.0026.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8486,156.2316l-.0055-.0019.0032-.0005.0022,0,0,.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.04,156.2931l.0033.0034-.0006.0014-.0007.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8741,156.2074l-.0026.004-.0007-.0027.0007-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.05,156.2317l-.0006.0007-.0041-.0027.0014-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-14"
              d="M2119.6514,156.2138l-.004.0012,0-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0215,156.4l.004.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.1052,156.52l.0014.004-.0025-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0255,156.4038l.0041.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8877,156.1709l.0115-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0917,156.4376l.004.0054Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0573,156.2505l.0006.0007-.0028.0008-.0026,0,.0029-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8614,156.16l.0054.0007-.0026.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-33"
              d="M2120.44,156.4423l.0024-.0017,0,.0038Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4456,156.3848l.002.0042-.0007.0014-.002-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8485,156.2371c-.0053-.0006-.0008-.0027-.0006-.0041Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8411,156.229l-.0041-.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8384,156.208l.0041-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-34"
              d="M2120.3471,156.3828l0-.0057Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-35"
              d="M2119.9053,156.5375l.0013-.0047v.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1855,156.4741v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-36"
              d="M2120.46,156.3046l-.0008-.0014-.0021-.001.0009-.0008.0027.0019v.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0883,156.4113l.0007.0034-.0027-.0021,0-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8485,156.1682l.0014-.002.0011.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0086,156.3627l-.0014.004.0014-.0047,0,.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.914,156.2431l.0007-.0027.0013.0022-.001.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4368,156.3782l-.0041-.0013.0007-.0013.0027,0,.0021.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.44,156.3776l.0017-.0006.0014.0027,0,.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-37"
              d="M2120.1127,156.1587l-.0043-.0016.007.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.1086,156.526l.0027.0055Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-19"
              d="M2120.56,156.46l-.0035,0,0-.0009,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9485,156.18l.0053.0016-.0066-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0505,156.2209l-.0028.0026-.0019-.0013.0033-.0027h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-28"
              d="M2119.889,156.1635h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-21"
              d="M2120.4753,156.2668l.0035-.0032-.0022.0032h-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.891,156.2154l.0021-.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9486,156.4457l-.0008-.0026.0019,0-.001.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-11"
              d="M2120.4665,156.5524l-.0027.0007h-.0013l.0013-.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-38"
              d="M2120.5773,156.4786l-.0009.0014-.0011-.0016.0007-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8931,156.22l-.0026-.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4456,156.38l.0018.0034h-.0018l-.0007-.0007,0-.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9384,156.48v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8547,156.2317l-.0007.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-39"
              d="M2120.3974,156.435l-.0013.0012-.0011-.0007v0l.0015-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-40"
              d="M2120.5575,156.4544l-.0042-.0029Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0667,156.2431v-.0013l.0041.0014-.0034.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.424,156.233l-.0041-.0013.0041-.0014.0007.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4489,156.389l0-.002.0026.004-.002-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-40"
              d="M2120.3677,156.4275l.0019.0035Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-10"
              d="M2120.1927,156.1541l.0042-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0363,156.4086l.0034-.0013-.0012.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2120.3626,156.4193l.0025.0026-.0006.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8567,156.2284l.0026,0,0,.0021-.0014.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-41"
              d="M2120.46,156.4187l-.0013-.0007.0029-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-42"
              d="M2119.8344,156.3566l.0006.0022-.0034,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9471,156.1492l-.0088-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4678,156.2094l-.0007-.0007-.001-.0021.0007-.0005.0013.0016.0005.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1011,156.1871l.0009.0013.0012,0-.0014.0009-.0029-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.87,156.2094l-.0013.0016-.0012-.001.0017-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8931,156.1607l.0044.001-.0044,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-19"
              d="M2119.87,156.2094l-.0008-.0014.0028-.0013-.0007.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-43"
              d="M2120.03,156.1682l.0021-.0006.0007.0016-.0027,0,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0877,156.4188l0,.0033h-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-34"
              d="M2120.5614,156.4608l.0028.0016-.0008.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0039,156.1885l.0034-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-44"
              d="M2120.4675,156.4538l.0016-.0031.0007.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.08,156.22l.0034.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2120.0491,156.22l-.0033.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8681,156.17h.0034l.0007.0013h-.0047Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0363,156.2357v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0748,156.4079l.002.0014,0,0,0,0h-.0022l0-.0017Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-45"
              d="M2119.8519,156.28l.0027-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8526,156.5761v-.0038l.0013.0031Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5287,156.4613l-.0021-.0027v-.0007l.0027.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0261,156.2025l.0028-.0012-.0013.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.087,156.4255l-.0013.0033-.0017-.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.01,156.3849l.0027.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0116,156.3278l-.0013-.0013.0009-.0009.0013.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8634,156.1858l-.0026.0023.0013-.0037Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9053,156.2175l-.0006-.0027.0025.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-26"
              d="M2120.5611,156.4545l.0013.0037-.0021-.0017Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0545,156.2708l-.0027-.0005.0014-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-46"
              d="M2120.5293,156.4606l-.0027-.0027.003.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0181,156.3984l.0027.0014-.0028,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0579,156.2668l-.0013.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-47"
              d="M2120.55,156.4532l.0025.0023-.0026-.0017v-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8843,156.2012l.0027-.0006-.0013.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8614,156.3863l-.0034.0007C2119.8583,156.3825,2119.86,156.3868,2119.8614,156.3863Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9039,156.2061l-.0033-.0031.004.0023Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.08,156.2358l-.0019.0006h-.0008l.0015-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-27"
              d="M2120.2281,156.38l-.0029,0,0-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8863,156.2067h-.0026l.0018-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0464,156.1532l.002-.0006,0,.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0005,156.1891l.0027-.0006-.0015.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8613,156.2269l-.0013-.0013.0017-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-21"
              d="M2120.5505,156.4507l-.0029-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9808,156.2874l.0012.0013-.0013.0008h0l-.0009-.0012.0008-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0518,156.256l.0034.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.068,156.24l0-.0013.0018.0009-.0009.0015h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9815,156.3653l-.0011.001-.0011-.0014.0013-.0008.0009.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4334,156.4451l.002-.0007,0,.003Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.858,156.1676l.0061.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.008,156.3525v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0086,156.3438l-.0019.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0107,156.3391l-.0014.0027,0-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-48"
              d="M2120.4821,156.474l0,0h.0019l0,.0016,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-49"
              d="M2120.0181,156.3222l-.002.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2120.5361,156.4416v-.0031l.0013.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9222,156.4329l-.0029-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2145,156.3329l-.001.0016-.0009-.0029Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-41"
              d="M2120.5348,156.4376l-.004-.0029Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.42,156.18h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8215,156.3545l.0068,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0343,156.1979l-.0007-.0014.0012-.0009.0011.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0951,156.4883l.0007.0026-.0019-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0134,156.389l.0026.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-50"
              d="M2119.8343,156.1634l.0007-.0013.0024.0022-.0024.0005h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0794,156.4224l-.0013.0015-.0009-.0007.0013-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0667,156.2431l.0007.0015-.0007.0019-.0013-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-51"
              d="M2119.8577,156.1625l-.0005.0008,0,0-.0014,0,.0008-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0971,156.4741l-.0007.0027-.0012-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.1012,156.466l-.0014.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7188,156.2425l.0018.0033-.0044-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2234,156.1865l.0016.0013-.003-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8243,156.1689h.0047l-.0013.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0262,156.3221l-.0027.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.039,156.27l-.0027.0014.001-.0022Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-18"
              d="M2120.4672,156.4262l.0011-.0014.0009.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-51"
              d="M2120.4811,156.2176l-.0014.0015-.0008-.0008.0009-.0013h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0491,156.2533l.0008.0019-.0018,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8985,156.2169l-.0027.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9147,156.2351l-.0014-.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-52"
              d="M2120.4825,156.4272l.0025.0013,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3226,156.1729h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.4745,156.5767l.0009.0027-.002-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.37,156.3775l.0025.0007.0015.002-.0021-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0964,156.4451l.0007.0027-.0019-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-31"
              d="M2120.4828,156.4305l.0036.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.44,156.2357l.0016.0039-.003-.0032Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.4037,156.549l.002,0,.0007.0006-.0012.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-19"
              d="M2120.4875,156.5685l.0006-.0025.0013.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9377,156.4377l-.002-.0015.0014-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0066,156.3485v.0027l-.0016-.0011.0014-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.8965,156.2128l.0006.002-.002-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2713,156.3438h.0029l-.0035.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3915,156.4457h-.002l-.0013-.0006.002-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-53"
              d="M2120.1731,156.1557l.0025-.0007,0,.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9336,156.4349l-.0061-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.87,156.1824l.004.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8755,156.2654l.0038-.0012-.0024.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4523,156.4322h-.0033l-.0006-.002.0039.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.25,156.1723l-.0061.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9012,156.1729l-.006,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7735,156.4282l0-.0028.0014,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8444,156.5194l-.0006.006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4435,156.4613h.0014l-.0028.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4057,156.516l-.002.002,0-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8614,156.6071l.0016-.0017.0007.0006-.0017.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0505,156.2209l-.0013-.0014.0033-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1032,156.5051l.0006.0061Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9161,156.1506h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8432,156.5v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-8"
              d="M2119.8668,156.3891v-.0028l.0013.0012-.0011.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9376,156.4883l.0008-.0061Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8377,156.2931l.001-.0035,0,.0022-.0011.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-38"
              d="M2120.5776,156.4834l-.0009-.0007.0007-.0009.0009.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.44,156.4h.0013l0,.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1484,156.1952l-.0024-.0021.0038.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0883,156.4113l-.0019.0007-.0014-.0006.0006-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-54"
              d="M2120.3605,156.4163l-.0023-.0014,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-41"
              d="M2120.2306,156.4994l-.001.0009-.0007-.0009h0l.0009-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.6661,156.2229l-.0013-.0014.0021,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4625,156.2776l.002-.0007.0007.0007-.0014.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-49"
              d="M2119.8951,156.19l.0027.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3658,156.3863l-.0006.0054Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.009,156.3083l-.0008.0007-.0008-.0007.0007-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-43"
              d="M2120.4974,156.23l.0025.0012-.0017,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-40"
              d="M2120.5291,156.5905l-.0027.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-55"
              d="M2120.4515,156.3172l.0015-.0015h0l0,.0008-.0017.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4388,156.3829l0,.0047Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.1677,156.5926l-.0006-.0006.0011-.0014.0007.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1849,156.156l.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0411,156.231l-.0021.002.0017-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2120.4584,156.43l.001.0005-.0012.0007-.0008-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-45"
              d="M2119.8786,156.1562l-.0011,0-.0008-.0008.001-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7128,156.3255l-.0014.0014-.0011-.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.44,156.1843l-.0053,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-56"
              d="M2120.4545,156.452l-.0026.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-57"
              d="M2119.8246,156.33l0,.003Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3354,156.1743h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8288,156.3378l-.0023-.0008,0-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3767,156.175l-.0028.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9019,156.1547l-.0047-.0007.002-.0007.0027.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.168,156.1553l.0021-.0006.0008.0016-.0014,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-4"
              d="M2120.4523,156.4316l-.0039-.0014.0039.0007,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9019,156.2087h.0013l.0014.0009v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0775,156.2087l0,.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-40"
              d="M2119.805,156.3467l.0007.0009-.0008.0008-.0008-.0008h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4651,156.4348l-.0053,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1281,156.1809l-.004-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7169,156.18l-.0048.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1214,156.1553l-.0047-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2119.9851,156.2906l-.0007-.0006.0009-.0008.0007.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.051,156.18l-.0027.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0086,156.3627v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9147,156.2594l-.0013.0006-.0014-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-58"
              d="M2120.3711,156.4335l.0021.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-59"
              d="M2120.52,156.4322l-.001.0006-.0009,0,0,0,.0008-.0007.0012.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5712,156.5517v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-59"
              d="M2120.4523,156.4316v-.0007l.0013.0011-.0009.001,0-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8316,156.3606h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3881,156.4309l.0011.0022-.0024-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-56"
              d="M2120.0606,156.2141l.0017-.0009,0,.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-60"
              d="M2119.8837,156.2587v.002l-.0008-.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.374,156.1783h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8329,156.1763l-.0017.0022,0-.0035Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7635,156.3336l.0006-.0047Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.55,156.4532l0,.0006-.0015-.0009.0006-.0009h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.34,156.1729l-.0047,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4368,156.3809v-.002l.0016.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2451,156.1524l.0013.0009-.0008.0007-.001-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.422,156.545l.0046,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-6"
              d="M2120.4456,156.4289v.0006l-.002.0008-.0007-.0008h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4057,156.53v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-12"
              d="M2120.561,156.2411l-.0021,0,0-.0005.0017,0,0,0,0,.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4543,156.1851l.0019.0015-.0026-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-61"
              d="M2120.3713,156.1722l-.0027-.0006.0027.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-56"
              d="M2120.3859,156.4266l-.0008-.0006.0007-.0009.0008,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-62"
              d="M2120.5558,156.2417l-.0006.0007-.0012,0,.0007-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1923,156.5071l.0007.0048Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0505,156.2472h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4665,156.4673l.0007-.0006.0034.0007-.0041,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2120.4449,156.3891l.002.0013-.002-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8736,156.1662l.0033.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.833,156.1621l-.0047.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-14"
              d="M2120.085,156.4114l.0014.0006,0,.0006-.0017,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8837,156.1642l-.0048,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-52"
              d="M2120.2339,156.4966l.0019-.0006.0008.0006-.0008.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8864,156.6206l.0027-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.0971,156.4923l.0013.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7108,156.3147l.0006.0047Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0248,156.1945l.0007.0006h-.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.066,156.4025l.004-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9161,156.25l-.0027,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-50"
              d="M2120.4253,156.4l-.002,0,.0016-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-54"
              d="M2120.3978,156.4113l-.0007,0-.0006-.0009,0,0,.0007,0,.0006.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.881,156.61l-.0022-.0007.0015-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9087,156.1506l-.0041.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8587,156.6038l.0015-.0011,0,.0017Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5057,156.1924l-.0041-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0484,156.1521l-.004-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1991,156.1871l-.0041.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8985,156.2559l.0041.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3478,156.3869l-.0008,0-.0005-.0009.0006-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4266,156.4282l.0007-.0041Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-63"
              d="M2119.8782,156.5774l-.0008-.0016.0015.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.906,156.2567l.0022.0005-.0009.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.94,156.1547l.0027-.0007,0,0,0,0-.0013.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-64"
              d="M2120.4324,156.3828l-.0006-.0011.0007,0,.0005.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-32"
              d="M2120.478,156.5652l-.0014.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-65"
              d="M2120.4816,156.2624l-.0009,0-.0006,0,.0008-.0009h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4753,156.2668h.0013l-.002.0013-.0013-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-34"
              d="M2119.8769,156.2033l.001,0-.001.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-42"
              d="M2120.1371,156.1561l-.0042,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0512,156.27h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0937,156.16l.004.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-66"
              d="M2120.4638,156.2755l-.0014-.0008.0021,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4233,156.4342l.0007-.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-20"
              d="M2119.9053,156.2081l.0009.0011-.0016.0008v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.168,156.5072l0-.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.35,156.3613v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-17"
              d="M2120.466,156.4309l.0006.0007-.0007,0-.0009,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.46,156.1837l-.004-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.424,156.2857l.0006.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.29,156.1634l-.0034-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8215,156.3593l-.004,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0343,156.2885v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2368,156.3579l.0007-.0041Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8688,156.1649l-.0041-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-32"
              d="M2119.8348,156.35l-.0012.0007-.0007-.0005.001-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5057,156.4754l-.0006-.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8918,156.1655h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-45"
              d="M2119.83,156.3434l-.0013-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4321,156.4377v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2363,156.1783l.0023.0011-.0031-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8053,156.1776l.0013.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9383,156.1661h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5585,156.4658l-.0005.0008-.0011-.0007.0005-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4834,156.2134h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4308,156.3431l.0006-.0041Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-67"
              d="M2120.4743,156.4442l.0007.0005-.0009.0008-.0006,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-68"
              d="M2120.1943,156.4665l-.0007.0005-.0005-.0007.0008-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1808,156.4472v-.0028l.0014.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.499,156.4573l.004.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-26"
              d="M2120.0085,156.3242l.0014-.0006,0,.0007-.0015.0006,0-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-29"
              d="M2120.1808,156.4472l.0014-.0015-.0014.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4557,156.4552l-.0027-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4038,156.4485l-.0042,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4125,156.449l-.0041-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3456,156.1735l-.0041-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8256,156.1749l-.0034-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1828,156.4531l-.0006-.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-34"
              d="M2120.448,156.3321V156.33l.0005.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-69"
              d="M2119.8586,156.1756l-.0009-.0012.0017-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-70"
              d="M2119.8228,156.33l-.002.0005,0-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.44,156.2175l.0021-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-32"
              d="M2120.2416,156.1743l0,.0012-.0011-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7115,156.2155l.0026.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.45,156.3254l.0006,0,0,.0007-.0005,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.656,156.2154l.0024,0,0,.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5611,156.4545l-.0008.002,0-.0022h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4307,156.4558l0-.0006.0019-.0007v.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0085,156.3242l0,.0007-.0013.0006.0006-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-71"
              d="M2119.6939,156.2148h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4523,156.2181l.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4226,156.4566h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5309,156.2131l.0021,0-.0008,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.856,156.1716l-.0034.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3587,156.1711l.002.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9485,156.1709v.0007l-.0016,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3652,156.17l.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7107,156.3087v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8209,156.1676l.002.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8721,156.1668l-.0034,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3821,156.1756l-.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2288,156.18l-.0006-.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.6627,156.22l.0018,0-.001.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2375,156.1763l.0007.001-.002,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4355,156.44v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2153,156.4768l-.0007-.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4388,156.3019l.0027-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4327,156.2972l.0007.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.58,156.4786l0,0-.0009.0007-.0005-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4226,156.439l.0007-.0035Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-55"
              d="M2119.8965,156.2128l-.0014.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7013,156.2127l-.0014.0011,0,0,.0017-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4185,156.2917l-.0033-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7405,156.183l-.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.347,156.3565l.002.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-72"
              d="M2120.49,156.4835l.0009,0,.0006,0-.0007.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1949,156.4863l0,.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.856,156.3593l-.0034-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4665,156.2229l.0007.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-73"
              d="M2120.5289,156.433l.0006.0008-.0007,0-.0006,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9364,156.4943v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9505,156.1844l-.0009-.0014.0016.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.3713,156.4336l-.001-.0014.0009,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-59"
              d="M2120.5726,156.4988l.0006,0,0,.0007,0,.0005h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8425,156.2884l.0013-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8425,156.36h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5185,156.5032l-.0006-.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.41,156.5024h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7912,156.3681h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9053,156.2081l-.0007.002-.0014-.0014.0013-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7189,156.231l.002.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-1"
              d="M2120.4247,156.2323l-.0007-.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.914,156.1864l.0021-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9411,156.1574l-.0034.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4436,156.43l.002-.0008,0,.0011-.0022,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9282,156.1573l.0034,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.114,156.5369v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4462,156.5375l.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0964,156.156l-.0033.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8047,156.4288v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4456,156.4289l-.0027.0006.0026-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-71"
              d="M2119.9073,156.4275l-.0014.0018.0007-.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.7114,156.2364v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4064,156.55l-.0007-.0006h.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8465,156.55l-.0006.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0775,156.2364h.0008l-.0007.0022-.0008-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4868,156.2377l.0013-.0013.0008.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5759,156.5544h-.0007l.0009-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.16,156.1547l.0028.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1491,156.1857l-.0034-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4672,156.4262h.002l-.0007.0013-.0013,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0511,156.2378l.0007.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8492,156.5714l.0006.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.5125,156.2006l.0033,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4442,156.4235h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.087,156.4221h.0006l-.0006.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0093,156.1992l.0033.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.2173,156.3917l.0007-.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.561,156.2411l0-.0007h.003Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1693,156.1877l-.0013.0007-.0007-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1619,156.1986l.0007.0011-.0021,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9073,156.2438l.0022,0-.0008.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.6831,156.1945l-.002-.0007.0022,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.987,156.1486l-.0027.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0768,156.41v-.0006h.0034Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.1559,156.1953l.0033,0-.0033,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.9527,156.6368l0,.0006-.0007-.0005,0,0h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0181,156.1824l0,.0007-.0075-.0008.0044-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-74"
              d="M2119.9485,156.1527l.0074-.0007-.0074.0013,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-33"
              d="M2119.9485,156.1527v.0006l-.0061.0014v-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-75"
              d="M2120.02,156.177l-.0007.0013-.0022-.0012v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-59"
              d="M2120.0254,156.1512l-.0014.0007-.0007,0,.0011-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0923,156.229l.0008-.0007,0,.003.0006.0009.0019-.0009h0l.0032-.0014.0091-.0048-.0006-.0014.0029-.0057.0006-.0049-.0007-.0072.0049-.0029.0028-.0035.008-.0025-.0005.0021-.0055.0044-.0017.0049.0021.0052.0073.0006.0111,0-.0113.0018-.0015.004,0,.0034-.0027-.0006-.0051.0034c0,.0016.0026.0041-.0016.0049l-.0051,0-.0055.0012-.0067,0-.0031,0h-.0037l-.0007-.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.1552,156.2618l0,.0031.0065.0008.01.0023.0075.005.0018.004-.0045.0023a.031.031,0,0,1-.0146-.0034l-.01.0021-.0106-.0026,0-.0028.0058-.01.0046-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-9"
              d="M2120.206,156.2814l-.0092-.01-.002-.0059.0069-.0057.0063-.0008.0018.0017-.0005.0027-.0055.0042c.0025.0039.008.0056.0087.0113l.002-.0029.003.0034-.0016.0011-.0025,0,.0008.003.0038.006-.0052.0053-.0083-.0042Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-76"
              d="M2120.1636,156.433l-.0051,0,0-.0043.0035-.0048.0031.0012-.0021.006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-77"
              d="M2120.17,156.258l-.0021.0035-.0025.0025-.0055-.0014.0007-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-78"
              d="M2120.35,156.2293l.0021.0083-.0084.0047.0054-.0054Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-79"
              d="M2120.23,156.2614l.0017.0044,0,.0028-.0027-.0013,0,0v-.0007l-.0011-.0024,0,.0027,0,.0014C2120.2251,156.2642,2120.2255,156.2636,2120.23,156.2614Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-80"
              d="M2120.15,156.4376l.0054.0171A.02.02,0,0,1,2120.15,156.4376Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-81"
              d="M2120.1652,156.4592l.0019.0076.0006.0081C2120.1653,156.4726,2120.1652,156.4719,2120.1652,156.4592Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-74"
              d="M2120.1271,156.2041l.003,0,.001,0,.0009.0014c-.0021.0012.002.0052-.0024.0051l-.0013-.0024Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-82"
              d="M2120.1429,156.2094l.0037.0025-.002.0023-.0038-.0039Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-83"
              d="M2120.1238,156.21l.0016-.0021.0016.0025-.0012.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-35"
              d="M2120.1626,156.2208l-.003-.0023.0015-.0013.0027.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-84"
              d="M2120.1007,156.2173l-.0031.0026-.0011-.0008.0031-.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-85"
              d="M2120.16,156.3408l-.0043.0059Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-86"
              d="M2120.2717,156.2594l-.0018.0032-.001.0011-.0009-.0016,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-87"
              d="M2120.1733,156.4153l-.002-.007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-84"
              d="M2120.1009,156.3754l.0047.002-.0032.0023Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-88"
              d="M2120.1422,156.281l-.002,0,.0027-.001.0018.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-89"
              d="M2120.1626,156.3262l-.0007.0007-.0036-.0069Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-86"
              d="M2120.1508,156.2087l.0045.0012,0,.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-90"
              d="M2120.2958,156.2555c-.0046,0-.0052-.0016-.0028-.0049Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-91"
              d="M2120.4156,156.308l0,0-.004-.0011.0005-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-74"
              d="M2120.2787,156.2746l.0052-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-92"
              d="M2120.1571,156.4168l-.0025.0037-.0007-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-92"
              d="M2120.1435,156.4872l.0054-.0043Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-93"
              d="M2120.2555,156.1823l-.003-.0013-.0008-.0014.0016,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-80"
              d="M2120.1788,156.2562l.0031-.0035Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-81"
              d="M2120.187,156.2866l-.0011.0022-.0013-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-94"
              d="M2120.1365,156.2212h-.0007l-.0018-.0028.0017.0011,0,.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-33"
              d="M2120.1552,156.4806l.0044-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-78"
              d="M2120.1471,156.4586l.0024-.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-92"
              d="M2120.163,156.4194l-.0013.0006-.0014-.001.0009-.0008,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-95"
              d="M2120.1762,156.2252l-.0015-.0025.0006,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-86"
              d="M2120.2457,156.177v-.0007l.0044.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-91"
              d="M2120.289,156.26l.0024.0022Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-96"
              d="M2120.3337,156.2428l.0016.0024-.0005,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-36"
              d="M2120.1491,156.4333l.0005-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-97"
              d="M2120.3173,156.2535l.0009.0008-.0013.0013-.0006-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-83"
              d="M2120.1759,156.3827l-.0009,0-.0012-.0013h0l.001-.0007h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-36"
              d="M2120.1309,156.2005l.0029,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-66"
              d="M2120.2436,156.1867l.0026.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-98"
              d="M2120.2335,156.1939v.0006l-.0035-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-79"
              d="M2120.23,156.26l.0032.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-99"
              d="M2120.1777,156.4012l-.0012.0027Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-100"
              d="M2120.0412,156.4l-.0006-.0028Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-101"
              d="M2120.1879,156.3031l.0014.0014v0l-.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-102"
              d="M2120.103,156.2179l-.0015.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2120.3193,156.2515l-.0027-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-83"
              d="M2120.3326,156.3157l-.0009.0007-.0008,0v0l.0006-.0009h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-91"
              d="M2120.3815,156.3777l.0026.003Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-103"
              d="M2120.2078,156.22l0-.0033v.0033Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-25"
              d="M2120.4345,156.2663l-.0015-.0015v0l.0005,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-30"
              d="M2120.2517,156.2462l-.0011.0007-.0006-.0008.001-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-104"
              d="M2120.1305,156.1868l.0022-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-35"
              d="M2120.3853,156.2512l-.001.0011-.0006,0,.0009-.001h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-105"
              d="M2120.3257,156.3114l.0008.0008-.0008.0008,0,0-.0006-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-63"
              d="M2120.3163,156.2468l-.0013.0008-.0009-.0008.0008-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-90"
              d="M2120.144,156.1967l-.0012,0-.0007-.0006.001,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0551,156.252l.0028-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-86"
              d="M2120.1521,156.4259l-.0011.0007,0-.0008.0009-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-106"
              d="M2120.135,156.2106l-.0009-.0007.0006-.0005.001,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-60"
              d="M2120.1581,156.2883l-.0007-.0012.0006-.0005.0008.0007v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-107"
              d="M2120.3559,156.2943h-.0017l-.0006-.0006.0009,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-43"
              d="M2120.1282,156.2938l0,.0023-.0008-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.0451,156.2964v.0015h-.0027l.0006-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-45"
              d="M2120.3086,156.3133l0-.0006.0007,0,.0005,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-97"
              d="M2120.1909,156.3089h-.0009l0-.0008.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-101"
              d="M2120.144,156.22l.0008-.0007.0006.0005-.0006.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-99"
              d="M2120.3168,156.3478l-.0006.0006-.0007,0,0-.0005h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-108"
              d="M2120.2079,156.22l.0017.0013-.0018-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-91"
              d="M2120.1934,156.29l.0008.0018,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-30"
              d="M2120.1488,156.2042l-.0009,0-.0006-.0006.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-89"
              d="M2120.1375,156.202l-.0008,0,.0006-.0006.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-109"
              d="M2119.8084,156.2582l.0137-.0058.0032.0008.002.0054-.0017.001-.0039,0-.0032-.0015-.0016-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-110"
              d="M2119.8251,156.2623l.0078-.0008-.002.0008.0035,0,.0022.0008v.0028l-.0021,0-.0016,0-.0047.0058-.002-.0033,0-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-111"
              d="M2119.825,156.2627c-.0061.0022-.0079.0078-.0107.0127l-.0028.0013,0-.0027c.0029-.005.0044-.0113.0116-.0121h.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-110"
              d="M2119.801,156.2461l0-.0057.0019-.0054.0031-.0015C2119.8037,156.2375,2119.8055,156.2429,2119.801,156.2461Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-82"
              d="M2119.7871,156.1925l-.0015.002h.0035l-.0136.0039.0051-.0029-.0016-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-112"
              d="M2119.8475,156.2673c-.0025.0061-.0073.0036-.0113.0038Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-79"
              d="M2119.8368,156.2729l-.0108.0046-.0021-.0005.0018-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-78"
              d="M2119.7776,156.2113l.0068-.0042.0043.0016A.0167.0167,0,0,1,2119.7776,156.2113Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-92"
              d="M2119.8451,156.1909l.0067-.006.0015,0v.0013l-.0026.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-35"
              d="M2119.8013,156.2222l.0036-.0012,0,.0007-.0069.0043.0029-.0038Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-79"
              d="M2119.8351,156.388l.0017.0023-.0013.0019-.0015-.0022Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-30"
              d="M2119.8845,156.1739l-.0039.0039-.0008.0009-.0006-.0013,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-66"
              d="M2119.7849,156.2246l-.0017.0048-.0016-.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-100"
              d="M2119.7969,156.2471l-.0008,0,0-.0045h.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-101"
              d="M2119.7854,156.2181l.0074-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-113"
              d="M2119.918,156.4978l.0016.001v0l-.0014.0016-.0013-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-114"
              d="M2119.8222,156.2035l-.0034.0023-.0006-.0008,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-95"
              d="M2119.8818,156.2346l.0014.002-.0006.0009h0l-.0016-.0016Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-115"
              d="M2119.8624,156.2468l.0047-.0031Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-30"
              d="M2119.6844,156.2147l.0039-.002,0,.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-92"
              d="M2119.8013,156.2222l-.0011-.0008.0033-.0018-.0022.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-116"
              d="M2119.8947,156.54l-.0034.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-117"
              d="M2119.7936,156.3852l-.0025-.0025Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-74"
              d="M2119.8047,156.2017h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-84"
              d="M2119.86,156.59l.0037-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-102"
              d="M2119.8111,156.2462h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-66"
              d="M2119.7789,156.2539l.0029.0026Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-118"
              d="M2119.8093,156.2537l-.0031-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-68"
              d="M2119.8647,156.598l-.0027-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-119"
              d="M2119.8425,156.48l.0022.0011,0,.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-35"
              d="M2119.8107,156.2242l.0006-.0008.0018-.0008,0,.0006-.0016.0011-.001,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-60"
              d="M2119.7723,156.1932l.002-.0024.0005.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-91"
              d="M2119.7838,156.2025l.0016-.003Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-120"
              d="M2119.738,156.2775l.0009.0021-.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-95"
              d="M2119.8313,156.202l-.0013,0-.0007-.0008.0012,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-115"
              d="M2119.8067,156.2066l-.0007.0009-.001-.0012.0007-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-99"
              d="M2119.8419,156.2572l.0016.0016-.0008,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2119.8126,156.21l.0006-.0022.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-102"
              d="M2119.7975,156.2083l-.0016.0015,0-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-121"
              d="M2119.8124,156.2126l.0032-.0018Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-74"
              d="M2119.8077,156.212l-.0007.0009-.0009,0,.0006-.0009h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-60"
              d="M2119.8837,156.2607l.0026.002Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-122"
              d="M2119.8262,156.21l-.0007.0008-.0006-.0007.0006-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-87"
              d="M2119.8965,156.176l-.0023,0,0-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-42"
              d="M2119.8136,156.2356l0-.0007.0009-.0005.0009.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-117"
              d="M2119.7814,156.204l0,0-.0014-.0006.0005-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-94"
              d="M2119.7817,156.2191l-.0012.0008,0-.0008.001-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-123"
              d="M2119.8255,156.202h.0023l0,.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-72"
              d="M2119.807,156.2323l.0027-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-107"
              d="M2119.8218,156.25l-.0006-.0007.001-.0012.0006.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-61"
              d="M2119.8165,156.2448l.0023-.0008,0,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-84"
              d="M2119.79,156.2235l.0027-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-124"
              d="M2119.8024,156.1938l-.0017.0016,0-.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-75"
              d="M2119.8106,156.2494l-.001,0-.0005-.0009.0008,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-98"
              d="M2119.856,156.1977l-.0005-.0008.0005,0,.001.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2119.85,156.2576l0-.0006.0009-.0008.0005.0007-.0009.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-115"
              d="M2119.8687,156.5848l.0009.0008-.0008,0-.0009-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-30"
              d="M2119.8908,156.2386l.0022.0021Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-122"
              d="M2119.881,156.1878l-.0014.0006-.0005-.0014Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-94"
              d="M2119.8759,156.2383l-.0007,0-.0008-.0009.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-125"
              d="M2119.8178,156.2318l-.0023.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-126"
              d="M2119.8132,156.2323l-.0006-.0006.001-.0006.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-80"
              d="M2119.872,156.5342l-.0008,0,.0007-.0007.0006.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-78"
              d="M2119.828,156.2062l-.0007,0-.0007-.0008.0009,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-59"
              d="M2119.8155,156.2257l0,.0007-.0006.0011h0l-.0005,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-115"
              d="M2119.8107,156.2242l-.0029.0012.0029-.0012Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-68"
              d="M2119.8527,156.4917l-.0005.0007-.0007-.0014,0,0h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-102"
              d="M2119.8892,156.2247l0,.0006-.0006-.0007,0-.0008Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-96"
              d="M2119.8712,156.2265l.0007.0006-.0007,0-.0005,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-75"
              d="M2119.8336,156.2064l-.0008-.001.0012-.0009,0,.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-127"
              d="M2119.79,156.38l.0009.0006,0,.0006-.0008,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-125"
              d="M2119.81,156.204l-.0005.0006-.0011,0,.0005-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-55"
              d="M2119.8163,156.2371l.0006.0006-.0006.0005-.0006,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-89"
              d="M2119.797,156.24l0-.0009.0005-.0006,0,.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-117"
              d="M2119.8052,156.2044l-.0011,0-.0006-.001.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-75"
              d="M2119.8814,156.2558l-.0006-.0006.0005,0,.0007,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2119.8639,156.6l.002,0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2119.8043,156.251l-.0008.0007-.0006,0,.0006-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-83"
              d="M2119.8621,156.3971l.0005.0009,0,.0007-.0006-.0007Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-103"
              d="M2119.8759,156.6114l.0008.0013,0,.0007-.0008-.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-128"
              d="M2119.8549,156.2445l.0006.0006-.0008,0,0-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4665,156.5524l-.0027-.0014.0007-.0013.0049-.0026-.0015.004Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-97"
              d="M2120.4572,156.4837l0-.0009,0,0,.0009-.0008,0,.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2120.4686,156.5443h-.0008l.0017-.0019Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-93"
              d="M2119.9122,156.1549h0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-129"
              d="M2119.9019,156.1547h.0022l-.0019.0015,0-.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-22"
              d="M2120.3679,156.4162l0-.0007.0005-.0005.0005.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-87"
              d="M2119.8246,156.1659l.0025,0,0,.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-5"
              d="M2119.8343,156.1634l.0007.0014-.0021-.0005Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-89"
              d="M2120.4773,156.5759l.0006.0005,0,.0007-.0005,0v0Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-13"
              d="M2120.0888,156.2719a.1025.1025,0,0,0,0,.0125l-.0028.0023-.001-.0028.0008-.0088Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-130"
              d="M2120.1614,156.2988l-.001.0021-.0037.0007-.0005-.0011.003-.0013Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-11"
              d="M2120.1305,156.2991l.0074.001Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-14"
              d="M2120.07,156.2853l-.0013-.0012.0012-.0009h0l.0011.0011Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-2"
              d="M2120.066,156.2862l-.0008.0007-.0007,0,.0005-.0006Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-14"
              d="M2120.1211,156.2205l.0013-.0027.0012.0015Z"
              transform="translate(-2119.6161 -156.1479)"
            />
            <path
              class="cls-19"
              d="M2120.1125,156.2218l.0007.0008-.0012.0014-.0006-.0009Z"
              transform="translate(-2119.6161 -156.1479)"
            />{" "}
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default WeAre;
